import React from 'react';
import { connectWithScope } from '#packages/apilib';
import { Scope } from '../entrypoint';
import { StripedArea } from './StripedArea';
import * as store from '../store';
import type { Rect } from 'types/documentServices';
import type { DraggedLayout } from '../plugin/types';

interface RestrictedZoneHighlighterProps {
  draggedLayout: DraggedLayout[];
  restrictedZones: Rect[];
}

const Component: React.FC<RestrictedZoneHighlighterProps> = ({
  draggedLayout,
  restrictedZones,
}) => (
  <>
    {restrictedZones.map((zone, index) => {
      return (
        <StripedArea
          draggedComponents={draggedLayout}
          key={index}
          x={zone.x}
          y={zone.y}
          width={zone.width}
          height={zone.height}
        />
      );
    })}
  </>
);

const mapStateToProps = () => ({
  restrictedZones: store.getRestrictedZones(),
  draggedLayout: store.getDraggedLayout(),
});

const ConnectedComponent = connectWithScope(
  () => Scope,
  Component,
  mapStateToProps,
  null,
  {
    rerenderOnMouseOps: true,
  },
);

export const RestrictedZoneHighlighter = ConnectedComponent;
